import React from "react";
import { useTranslation } from "react-i18next";
import { useA11yAnnouncements } from "../../hook/useA11yAnnouncements";

export const RegistrationA11yToggle = () => {
  const { t } = useTranslation();
  const { isOn, toggle } = useA11yAnnouncements();
  const onMessage = t("A11Y_ANNOUNCEMENTS_ON", {
    defaultValue: "Automatic announcements on",
  });
  const offMessage = t("A11Y_ANNOUNCEMENTS_OFF", {
    defaultValue: "Automatic announcements off",
  });

  return (
    <button
      type="button"
      id="a11yToggle"
      className="registration-a11y-toggle"
      aria-pressed={isOn}
      aria-label={t("A11Y_AUTOMATIC_ANNOUNCEMENTS", {
        defaultValue: "Automatic announcements",
      })}
      onClick={() =>
        toggle({
          onMessage,
          offMessage,
        })
      }
    >
      <span className="registration-a11y-toggle__label">
        {t("A11Y_SCREEN_READER_LABEL", {
          defaultValue: "Screen Reader",
        })}
      </span>
      <span className="registration-a11y-toggle__switch" aria-hidden="true">
        <span className="registration-a11y-toggle__thumb" />
      </span>
      <span className="registration-a11y-toggle__state" aria-hidden="true">
        {isOn
          ? t("A11Y_SCREEN_READER_ON_SHORT", { defaultValue: "ON" })
          : t("A11Y_SCREEN_READER_OFF_SHORT", { defaultValue: "OFF" })}
      </span>
    </button>
  );
};
